import React from 'react';

export const SEE_MORE_TRACKING_CATEGORY = 'Quote See More';

interface SeeMoreLinkProps {
  action: string;
  href: string;
  label: string;
}

const SeeMoreLink: React.FC<SeeMoreLinkProps> = ({ action, href, label }) => (
  <a
    className="text-xs font-semibold text-blue-600 hover:text-blue-700 hover:underline whitespace-nowrap capitalize"
    data-action={action}
    data-category={SEE_MORE_TRACKING_CATEGORY}
    href={href}
  >
    {label} →
  </a>
);

export default SeeMoreLink;
